<template>
  <CModal size="lg" alignment="center" :visible="show" @close="$emit('close')">
    <CModalBody class="d-flex justify-content-center align-items-center">
      <CImage class="mb-4" rounded thumbnail :src="image" />
    </CModalBody>
  </CModal>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup() {},
}
</script>
